import Hero from './Hero'

export default Hero



// WEBPACK FOOTER //
// ./src/components/Layout/Hero/index.js